import React from "react"

import { styled } from "@mui/material"

import { useCustomerInfo } from "@cirrus/common/CustomerInfo"
import { useDateTimeProvider } from "@cirrus/core/dateTime"
import { useTranslations } from "@cirrus/core/i18n/provider"
import { MatSymbol } from "@cirrus/ui-kit-ts"

import { Grid } from "../containers"
import { useNews } from "../providers/News"

export const NewsBlock = () => {
  const { i18n } = useTranslations()
  const newsContext = useNews()
  const customerInfoContext = useCustomerInfo()
  const { formatter } = useDateTimeProvider()

  if (!newsContext.data || !customerInfoContext.data) return null

  const { zone, formats, stformat } = customerInfoContext.data.regionalSettings
  const { date, text } = newsContext.data
  const createdAt = formatter.formatWithTimezone({ date, zone, locale: formats, format: `L ${stformat}` })

  return <Container>
    <Grid>
      <Title><MatSymbol name="news" />{i18n("General:News")}</Title>
      <Date>{createdAt}</Date>
    </Grid>
    <Text dangerouslySetInnerHTML={{ __html: text }} />
  </Container>
}

const Container = styled("div")({
  background: "#F2F2F2", display: "grid", rowGap: "10px", padding: "10px 16px", borderRadius: "4px"
})

const Title = styled("span")({
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: 0,
  color: "#1A1A1A",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  marginBottom: "4px"
})

const Date = styled("span")({
  color: "#1A1A1A",
  opacity: .7,
  fontSize: "1.4rem",
  fontStyle: "italic",
  fontWeight: 400,
  lineHeight: "1.6rem",
  letterSpacing: 0
})

const Text = styled("span")({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: 0,
  color: "#1A1A1A",
  maxHeight: "calc(2rem * 13)",
  overflow: "auto"
})
